import { SettingsSideBarConstants } from 'constants/SideBarConstants';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NormalLNBButton } from 'styles/Global/buttonStyles';

const SettingsSideBar = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [path, setPath] = useState('');

    useEffect(() => {
        setPath(pathname);
    }, [pathname]);

    return (
        <>
            {SettingsSideBarConstants(path).map((list, idx) => {
                if (!list.path) return null;

                return (
                    <NormalLNBButton key={idx} $idx={idx} $path={path} $listPath={list.path} onClick={() => navigate(list.path)}>
                        {list.icon}
                        <span>{list.name}</span>
                    </NormalLNBButton>
                );
            })}
        </>
    );
};

export default SettingsSideBar;
